import { useEffect } from 'react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
export var SYNC_BLOCK_FETCH_INTERVAL = 3000;

// Component that refreshes synced block subscriptions at regular intervals
// this is a workaround for the subscription mechanism not being real-time
export var SyncBlockRefresher = function SyncBlockRefresher(_ref) {
  var syncBlockStoreManager = _ref.syncBlockStoreManager,
    api = _ref.api;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['connectivity'], function (states) {
      var _states$connectivityS;
      return {
        mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
      };
    }),
    mode = _useSharedPluginState.mode;
  useEffect(function () {
    var interval = -1;
    if (mode !== 'offline') {
      interval = window.setInterval(function () {
        var _document;
        // check if document is visible to avoid unnecessary refreshes
        if (((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) === 'visible') {
          syncBlockStoreManager.referenceManager.refreshSubscriptions();
        }
      }, SYNC_BLOCK_FETCH_INTERVAL);
    } else if (interval !== -1) {
      window.clearInterval(interval);
    }
    return function () {
      window.clearInterval(interval);
    };
  }, [syncBlockStoreManager, mode]);
  return null;
};